import type { AccessibilityAssistantPaneProps } from './components/AccessibilityAssistantPane';
import type { AccessibilityAssistantSidePaneProps } from './components/AccessibilityAssistantSidePane';
import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyModule,
    LazyImport,
    type LazyComponent,
    LazyAction,
} from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AccessibilityAssistant" */ './lazyIndex'),
    { name: 'AccessibilityAssistant' }
);

export const AccessibilityAssistantPane: LazyComponent<
    AccessibilityAssistantPaneProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.AccessibilityAssistantPane);

export const AccessibilityAssistantSidePane: LazyComponent<
    AccessibilityAssistantSidePaneProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.AccessibilityAssistantSidePane);

export const AccessibilityAssistantDrawer: LazyComponent<unknown, void> = createLazyComponent(
    lazyModule,
    m => m.AccessibilityAssistantDrawer
);

export const lazyOpenAccAssistant: LazyImport<
    typeof lazyIndex.openAccAssistant,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.openAccAssistant);
export const lazyOpenAccAssistantInSidePane: LazyImport<
    typeof lazyIndex.openAccAssistantInSidePane,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.openAccAssistantInSidePane);
export const lazyResetAccAssistantSidePane: LazyImport<
    typeof lazyIndex.resetAccAssistantSidePane,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.resetAccAssistantSidePane);
export const lazyCloseAccAssistant: LazyImport<
    typeof lazyIndex.closeAccAssistant,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.closeAccAssistant);

export const lazyResetAccessibilityAssistantPane: LazyAction<
    typeof lazyIndex.resetAccAssistantPane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.resetAccAssistantPane);
